export const SUPPORT_EMAIL = 'support.sonar@openeconomics.eu';
